(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sm-faq-degradee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFaq = (section) => {
      if (!section || section.dataset.faqInitialized === 'true') return;

      const singleOpen = section.dataset.singleOpen === 'true';
      const items = Array.from(section.querySelectorAll('.sm-faq__item'));

      section.dataset.faqInitialized = 'true';

      if (!singleOpen) return;

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.open) {
              otherItem.open = false;
            }
          });
        });
      });
    };

    const initializeAllFaqs = (root = document) => {
      root.querySelectorAll('[data-sm-faq]').forEach(initializeFaq);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeAllFaqs();
      });
    } else {
      initializeAllFaqs();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAllFaqs(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('.sm-faq__item');

      if (item) {
        item.open = true;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-mirror-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSlider = (section) => {
      if (!section || section.dataset.smSliderInitialized === 'true') return;

      const viewport = section.querySelector('[data-slider-viewport]');
      const track = section.querySelector('[data-slider-track]');
      const previousButton = section.querySelector('[data-slider-previous]');
      const nextButton = section.querySelector('[data-slider-next]');
      const dots = Array.from(section.querySelectorAll('[data-slider-dot]'));
      const cards = Array.from(section.querySelectorAll('.sm-card-slider__card'));

      if (!viewport || !track || cards.length === 0) return;

      section.dataset.smSliderInitialized = 'true';

      const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      const getCardStep = () => {
        const firstCard = cards[0];
        const trackStyles = window.getComputedStyle(track);
        const gap = parseFloat(
          trackStyles.columnGap || trackStyles.gap || '0'
        );

        return firstCard.getBoundingClientRect().width + gap;
      };

      const getClosestCardIndex = () => {
        const step = getCardStep();

        if (!step) return 0;

        return Math.max(
          0,
          Math.min(
            cards.length - 1,
            Math.round(viewport.scrollLeft / step)
          )
        );
      };

      const updateDots = () => {
        const currentIndex = getClosestCardIndex();

        dots.forEach((dot, index) => {
          const active = index === currentIndex;

          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const scrollToCard = (index) => {
        const safeIndex = Math.max(
          0,
          Math.min(cards.length - 1, index)
        );

        viewport.scrollTo({
          left: cards[safeIndex].offsetLeft - track.offsetLeft,
          behavior: reducedMotion ? 'auto' : 'smooth'
        });
      };

      previousButton?.addEventListener('click', () => {
        const currentIndex = getClosestCardIndex();
        const previousIndex =
          currentIndex <= 0 ? cards.length - 1 : currentIndex - 1;

        scrollToCard(previousIndex);
      });

      nextButton?.addEventListener('click', () => {
        const currentIndex = getClosestCardIndex();
        const nextIndex =
          currentIndex >= cards.length - 1 ? 0 : currentIndex + 1;

        scrollToCard(nextIndex);
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          scrollToCard(Number(dot.dataset.sliderDot));
        });
      });

      let scrollTimer;

      viewport.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(updateDots, 80);
        },
        { passive: true }
      );

      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          scrollToCard(getClosestCardIndex() - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          scrollToCard(getClosestCardIndex() + 1);
        }
      });

      updateDots();
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('.sm-card-slider').forEach(initializeSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initializeAll();
      });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const block = event.target.closest('.sm-card-slider__card');
      const section = event.target.closest('.sm-card-slider');
      const viewport = section?.querySelector('[data-slider-viewport]');
      const track = section?.querySelector('[data-slider-track]');

      if (block && viewport && track) {
        viewport.scrollTo({
          left: block.offsetLeft - track.offsetLeft,
          behavior: 'smooth'
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
